import type { TimesheetFilters } from '@/services/timesheets/types';

export const timesheetQueryKeys = {
  all: ['timesheets'] as const,
  
  // My timesheets (for individual users)
  myTimeEntries: (profileId: string, month?: Date, timezone?: string) =>
    ['timesheets', 'my', profileId, month?.toISOString(), timezone] as const,
  
  // Company timesheets (for managers)
  companyTimeEntries: (filters?: TimesheetFilters) => 
    ['timesheets', 'company', filters] as const,
  companyTimeEntriesWithComments: (filters: TimesheetFilters) => 
    ['timesheets', 'company', 'withComments', filters] as const,
  
  // Company profiles
  companyProfiles: () => ['timesheets', 'profiles'] as const,
  
  // Comment-related keys
  timeEntryComments: (entryId: string) => ['timeEntryComments', entryId] as const,
};
